import { Controller } from "@hotwired/stimulus"

// Карточка товара носит своё содержимое модалки в <template> — на клик
// контент клонируется в общий на страницу <dialog>. Так карточки не тащат
// за собой 24 живые формы/Choices.js сразу при загрузке страницы — они
// оживают только когда открыт конкретный товар.
export default class extends Controller {
  static targets = ["dialog", "body"]

  open(event) {
    const card = event.currentTarget.closest(".kit-product-card")
    const template = card.querySelector("template")
    this.bodyTarget.replaceChildren(template.content.cloneNode(true))

    this.index = 0
    this.images = this.bodyTarget.querySelectorAll("[data-gallery-image]")
    this.updateGallery()

    this.dialogTarget.showModal()
  }

  updateGallery() {
    this.images.forEach((img, i) => img.classList.toggle("is-active", i === this.index))
  }

  prevPhoto() {
    this.index = (this.index - 1 + this.images.length) % this.images.length
    this.updateGallery()
  }

  nextPhoto() {
    this.index = (this.index + 1) % this.images.length
    this.updateGallery()
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
